import { OuterBounds } from '@components/page/Master.tsx';
import { useEffect } from 'react';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useMenuContext } from '@/contexts/MenuContext.tsx';
import { UsaContent } from '@pages/Usa/components/UsaContent.tsx';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export type UsatourDate = {
  id: string;
  date: string;
  location: string;
  venue: string;
  url: string;
  cta: string; // not in default tourDate type
  campaign_title: string;
  campaign_text: string;
  img: string;
  date_format: string;
  status: string;
  isPublic: boolean;
  x: number;
  y: number;
};

export interface UsaProps {
  csrf_token?: string;
  fase: number;
  tourDates: UsatourDate[];
}

export function UsaPage({ tourDates, fase }: UsaProps) {
  const { setInvert } = useMenuContext();

  useEffect(() => {
    setInvert(true);
    return () => setInvert(false);
  }, [setInvert]);

  return (
    <OuterBounds className="tw-bg-[#000]">
      <UsaContent
        fase={fase}
        tourDates={tourDates}
      />
    </OuterBounds>
  );
}
